// @flow

import type { Merchant } from '@tectonics/prs/merchant/types';
import { getMerchantConfig } from '../get-merchant-config';

export function shouldHideBrazilIofOriginalAmount(merchant: Merchant): boolean {
  const merchantConfig = getMerchantConfig(merchant);

  return merchantConfig
    ? Boolean(merchantConfig.hide_brazil_iof_original_amount)
    : false;
}
